angular.module('mercury.services', [
'mercury.services.applicationMenu',
'mercury.services.auth',
'mercury.services.logging',
'mercury.services.analytics',
'mercury.services.dialog',
'mercury.services.errorsinterceptor',
'mercury.services.throttleinterceptor',
'mercury.services.multisite',
'mercury.services.notifications',
'mercury.services.reporttime',
'mercury.services.userinfo',
'mercury.services.features',
'mercury.services.tax',
'mercury.services.title',
'mercury.services.chartHelpers',
'mercury.services.helperUtils',
'mercury.services.payroll',
'mercury.services.shiftHelpers',
'mercury.services.companyChange'
]);
